import { render, staticRenderFns } from "./inventory-manager.vue?vue&type=template&id=0a8c4a7e&scoped=true"
import script from "./inventory-manager.vue?vue&type=script&lang=js"
export * from "./inventory-manager.vue?vue&type=script&lang=js"
import style0 from "./inventory-manager.vue?vue&type=style&index=0&id=0a8c4a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c4a7e",
  null
  
)

export default component.exports